export const FRIENDLY_CAPTCHA_ENDPOINT = 'GLOBAL1';

export enum CaptchaValidationErrorCodes {
  SECRET_MISSING = 'secret_missing', // Missing secret (API key), status 400
  SECRET_INVALID = 'secret_invalid', // Invalid API key, status 401
  SOLUTION_MISSING = 'solution_missing', // Missing CAPTCHA solution, status 400
  BAD_REQUEST = 'bad_request', // General bad request error, status 400
  SOLUTION_INVALID = 'solution_invalid', // CAPTCHA solution is invalid, status 200
  SOLUTION_TIMEOUT_OR_DUPLICATE = 'solution_timeout_or_duplicate', // CAPTCHA solution expired or already used, status 200
}
